import './App.css';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Services from './pages/Services';
import Contact from './pages/Contact/Contact';
import { BrowserRouter as Router, Routes,Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import Bathrooms from './pages/Bathrooms/Bathroom';
import Electrical from './pages/Electrical/Electrical';
import Electricals from './pages/Electricals/Electricals';
import Flooring from './pages/Flooring/Flooring';
import Plumbings from './pages/Plumbing/Plumbings';
import Paintings from './pages/Painting/Paintings';
import Painting from './pages/Painting/Painting';
import Additional from './pages/Additional/Additional';
import ContactTest from './pages/Contact/ContactTest';
import AOS from 'aos';
import 'aos/dist/aos.css'; // Import AOS styles
import { useEffect } from 'react'

function App() {
    useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset:200});
  }, [])
  return (


      <Router>
      <div className="App">
      <Navbar/>
        <ScrollToTop/>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/services' element={<Services/>}/>
          <Route path='/services/electrical' element={<Electricals/>}/>
          <Route path='/services/electricals' element={<Electrical/>}/>
          <Route path='/services/bathrooms' element={<Bathrooms/>}/>
          <Route path='/services/flooring' element={<Flooring/>}/>
          <Route path='/services/plumbing' element={<Plumbings/>}/>
          <Route path='/services/painting' element={<Paintings/>}/>
          <Route path='/services/paintingo' element={<Painting/>}/>
          <Route path='/services/additional' element={<Additional/>}/>
          <Route path='/contact' element={<Contact/>}/>
          <Route path='/test' element={<ContactTest/>}/>
        </Routes>
        <Footer/>
        </div>
      </Router>
  );
}

export default App;







